// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Scvn","clinicsSelect":"TableHeading_clinicsSelect__1c33j"};